import { AuctionState, DirectSaleState } from '~/apiClient';
import type { PlatformSaleItemEntity } from '~/types/sale.type';

export type UseSdpToBeApprovedReturnType = {
    hasToBeApproved: ComputedRef<boolean>;
};

export const useSdpToBeApproved = (sale: Ref<PlatformSaleItemEntity | undefined>): UseSdpToBeApprovedReturnType => {
    const { isLoggedIn } = useAuthUtils();

    const hasToBeApproved = computed<boolean>(
        () =>
            (sale.value?.state === AuctionState.ToBeApproved || sale.value?.state === DirectSaleState.ToBeApproved) &&
            (!isLoggedIn.value || !!sale.value?.canActForSellerCompany)
    );

    return { hasToBeApproved };
};
